import BaseReducer from "./BaseReducer";

class MachineSessionModalReducer extends BaseReducer {
  domain = "Modals";
  type = "MachineSession";

  initialState = {
    open: false,
  };
}

const reducer = new MachineSessionModalReducer();

export default reducer;
